module.exports = __webpack_public_path__ + "static/sc-01.0fd50c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/sta/sc-01.png
// module id = 93
// module chunks = 81852922322886 88197199937824 213720915766396